<template>
  <div class="ui-sidebar-scroll-hint">
    <UiIcon icon="$scrollDown" class="mr-1" />
    <UiText variant="body-3" color="text-accent">
      {{ $t('dictionary.sidebar.scrollDown.text') }}
    </UiText>
  </div>
</template>

<script setup lang="ts">
import { UiIcon, UiText } from '~/ui';
</script>

<style scoped lang="scss">
.ui-sidebar-scroll-hint {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 0px;
  z-index: 1;
  width: 100%;
  height: 70px;
  color: rgb(var(--v-theme-text-accent));
  background: linear-gradient(
    180deg,
    rgba(246, 247, 249, 0) 0%,
    rgba(246, 247, 249, 0.98) 68.75%,
    #f6f7f9 100%
  );
}
</style>
